import { Link } from 'react-router-dom'
//import ReactTooltip from 'react-tooltip'
import Header from './header'
import Navigation from './navigation'

function Group(props) {
  const items = props.products.map((product) => 
    <div key={ product.id } className="col item">
      <Link to={ props.category + '/pid-' + product.id }>
        <label className="animate__animated animate__bounceIn" data-tip data-for={ 'pid-' + product.id }>
          <input
            type="radio"
            name="items"
            value={ product.name }
          />
          <img className="animate__animated animate__fadeIn" src={ '/' + product.image } alt={ product.name } />
          <p>{ product.name }</p>
        </label>
        {
        /* 
        * Disabled tooltip for now, react-tooltip is not support react 18 yet. (not hide on mouseleave)
        *
        <ReactTooltip id={ 'pid-' + product.id } place="top" effect="solid">
          <h6>{ product.tips }</h6>
        </ReactTooltip>
      */
      }
      </Link>
    </div>
  )

  return (
    <div className="layout">
      <Header />
      <div className="content">
        <div className="category">
          <div className="group">
            <h3>{ props.title }</h3>
            <p className="subtitle">{ props.subtitle }</p>
            <div className="row item-list">
              { items }
            </div>
          </div>
          <Navigation 
            prev = { props.prev }
            prevStep = { props.prevStep }
          />
        </div>
      </div>
    </div>
  )
}

export default Group;